import { URL } from '@ux/util';
import hasWindow from './hasWindow';

/**
* Compares two URLs, ignoring any trailing slashes.
*
* @param {string} url1 URL to check.
* @param {string} url2 URL to compare.
* @param {boolean} ignoreQueryStrings Whether to ignore query strings.
* @param {boolean} ignoreHash Whether to ignore the url hash.
* @returns {boolean} Whether URLs match
*/
function urlMatches(url1, url2, ignoreQueryStrings = false, ignoreHash = false) {
  if (typeof url1 !== 'string' || typeof url2 !== 'string') {
    return false;
  }

  const urlObj1 = new URL(url1);
  const urlObj2 = new URL(url2);

  if (ignoreQueryStrings) {
    urlObj1.set('query', {});
    urlObj2.set('query', {});
  }

  if (ignoreHash) {
    urlObj1.set('hash', '');
    urlObj2.set('hash', '');
  }

  url1 = urlObj1.href;
  url2 = urlObj2.href;

  return url1.replace(/\/$/, '') === url2.replace(/\/$/, '');
}

const isExternalLink = new RegExp('^(?:[a-z]+:)?//', 'i');

/**
* Returns true if window.location.href matches the links href or relative path.
*
* @param {string} href href to verify against window.location.href
* @param {string} browserUrlStr URL in the browser as string
* @param {boolean} ignoreQueryStrings Whether to ignore query strings.
*
* @returns {boolean} Whether href is active
*/
function isLinkActive(href, browserUrlStr) {
  const browserUrl = new URL(browserUrlStr);

  if (!hasWindow() || !href) {
    return false;
  }

  if (!isExternalLink.test(href)) {
    if (browserUrl.pathname === href.split('?')[0]) {
      return true;
    }
  } else if (urlMatches(browserUrlStr, href, true, true)) {
    return true;
  }

  return false;
}

/**
  * Returns true when the navItem is active.
  *
  * @param {object} navItem checks href of parent or children
  * @param {string} browserUrlStr URL in the browser as string
  *
  * @returns {boolean} validates href of active element
  */

function isNavItemActive(navItem, browserUrlStr) {
  if (navItem.active != null) {
    return navItem.active;
  }
  return isLinkActive(navItem.href, browserUrlStr)
    || navItem.children?.some((child) => isNavItemActive(child, browserUrlStr))
    || false;
}

export {
  isNavItemActive
};
